import { defineAsyncComponent } from "vue";
const de = {
  cwcWidgetApi: {
    createAlreadyExists: "CwcWidget kann nicht erstellt werden, da bereits ein CwcWidget mit dieser cwcId existiert",
    notFound: "CwcWidget nicht gefunden"
  },
  cwcWidgetList: {
    name: "Nach Bezeichnung oder CWC Id suchen",
    loading: "Lade CwcWidget",
    headerLabel: "Bezeichnung",
    headerCwcId: "CWC Id",
    headerWidgetType: "Widgetart",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am"
  },
  cwcWidget: {
    selectorPlaceholder: "Cwc Widget auswählen",
    cwcWidgetLabel: "CwcWidget",
    configureWidget: "Widget Konfigurieren",
    newWidget: "Neues Widget",
    widgetTypeNotAllowed: "Diese Widgetart ist nicht erlaubt"
  }
};
const en = {
  cwcWidgetApi: {
    createAlreadyExists: "Can't create CwcWidget because another CwcWidget with this cwcId already exists",
    notFound: "CwcWidget not found"
  },
  cwcWidgetList: {
    name: "Search by label or CWC Id",
    loading: "Loading CwcWidget",
    headerLabel: "Label",
    headerCwcId: "CWC Id",
    headerWidgetType: "Widget type",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at"
  },
  cwcWidget: {
    selectorPlaceholder: "Select Cwc Widget",
    cwcWidgetLabel: "CwcWidget",
    configureWidget: "Configure Widget",
    newWidget: "New Widget",
    widgetTypeNotAllowed: "This widget type is not allowed"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/cwc-widget",
    children: [
      {
        path: "",
        name: "cwc_widget_list",
        component: () => import("./cwc-widget-list.view-BeIKCZrA.js").then((n) => n.d),
        meta: { requiredRight: "navigate_list_cwc_widget" }
      }
    ]
  }
];
const CwcWidgetContentBlock = defineAsyncComponent(() => import("./cwc-widget-content-block-HPshbJvW.js"));
const cwcWidgetModule = {
  messages,
  routes,
  contentBlocks: [
    {
      type: "CWC_WIDGET",
      label: "cwcWidget.cwcWidgetLabel",
      icon: "book",
      component: CwcWidgetContentBlock,
      defaultValue: { type: "CWC_WIDGET" }
    }
  ]
};
export {
  CwcWidgetContentBlock,
  cwcWidgetModule
};
//# sourceMappingURL=index.es.js.map
